import Palette from '../colors/palette'

export default {
  primaryShadow: `0px 1px 6px ${Palette.shadowColor}`,
  secondaryShadow: `0px 1px 4px ${Palette.shadowColor}`
}



// WEBPACK FOOTER //
// ./src/theme/shadows/index.js